import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfigService } from 'src/app/core/service/config.service';
import { ApiUserService } from '../../../core/service/api-user.service';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-privacy-setting',
  templateUrl: './privacy-setting.component.html',
  styles: [
  ]
})
export class PrivacySettingComponent implements OnInit {
  loading: boolean = false;
  PrivacySettingToggle: boolean = false;
  constructor(
    private _config: ConfigService,
    private apiUserService: ApiUserService,
    public dialogRef: MatDialogRef<PrivacySettingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: boolean
  ) {
    this.PrivacySettingToggle = data

  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

  }

  onSubmit(): void {

    this.loading = true;
    this.apiUserService.UpdatePrivacySetting({ is_anonymous: this.PrivacySettingToggle }).subscribe({
      next: (res: any) => {
        this.loading = false;
        this._config.toastrService.success(res.message)
        let CurrentUser = JSON.parse(localStorage.getItem("auth") || "")
        if (CurrentUser) {
          CurrentUser = res.data
        }
        localStorage.setItem('auth', JSON.stringify(CurrentUser));
        console.log(CurrentUser);
        window.location.reload();
        this.dialogRef.close(true);
      },
      error: (error: any) => {
        this.loading = false;
        this._config.showErrors(error)

      }
    })

  }
}
